import { ArrowRight, Calculator, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export default function FinalCta() {
  return (
    <section className="bg-[#F2F1EE] py-24 sm:py-32" data-testid="final-cta">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6">
        <p className="flex items-center justify-center gap-2 text-xs font-semibold text-slate-500">
          <span className="h-2 w-2 rounded-full bg-saffron" /> IndiaFast Global Couriers
        </p>
        <h2 className="mt-4 font-heading text-4xl font-medium leading-[1.08] tracking-tight text-navy sm:text-6xl">
          Ready to send it<br /><span className="text-saffron">across the world?</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-500 sm:text-lg">
          Get a fast quote and let IndiaFast take care of the journey — pickup, paperwork, customs and doorstep delivery.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <Link to="/rate-calculator" data-testid="final-cta-quote-btn"
                className="group inline-flex items-center gap-2 rounded-full bg-saffron py-2 pl-6 pr-2 text-sm font-bold text-white shadow-xl shadow-saffron/30 transition-colors hover:bg-saffron-hover">
            <Calculator className="h-4 w-4" /> Get a Quote
            <span className="grid h-8 w-8 place-items-center rounded-full bg-white/20 transition-transform group-hover:translate-x-0.5">
              <ArrowRight className="h-4 w-4" />
            </span>
          </Link>
          <Link to="/track" data-testid="final-cta-track-btn"
                className="group inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white py-2 pl-6 pr-2 text-sm font-bold text-navy transition-colors hover:border-saffron hover:text-saffron">
            Track Shipment
            <span className="grid h-8 w-8 place-items-center rounded-full bg-saffron/10 text-saffron transition-colors group-hover:bg-saffron group-hover:text-white">
              <ArrowRight className="h-4 w-4" />
            </span>
          </Link>
          <a href="tel:9783807838" data-testid="final-cta-contact-btn"
             className="inline-flex items-center gap-2 rounded-full bg-emerald-600 px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-emerald-700">
            <Phone className="h-4 w-4" /> Contact IndiaFast
          </a>
        </div>
      </div>
    </section>
  );
}
